import { AutoComplete } from '@elotech/components';
import { CustomLinkExternal, Label } from 'common/components';
import { UNCPessoa } from 'common/type';
import { formataCpfOuCnpj, getUrl } from 'common/utils';
import { FC } from 'react';

import { PessoaSearchPropsBase } from './PessoaSearch';

export type PessoaSearchPropsSingle = PessoaSearchPropsBase & {
  value: any;
  onSelect: (name: string, value: UNCPessoa) => void;
};

export const PessoaSearchSingle: FC<PessoaSearchPropsSingle> = ({
  name,
  value,
  error,
  onSelect,
  onSearch,
  onCreateValue,
  noLabel = false,
  label = 'Pessoa',
  showCodigo = false,
  disabled = false
}) => {
  return (
    <>
      {!noLabel && <Label>{label}</Label>}
      <AutoComplete<UNCPessoa>
        name={name}
        value={value}
        autoFocus={false}
        onSelect={onSelect}
        isDisabled={disabled}
        className={!!error ? 'error' : ''}
        getOptionValue={pessoa => pessoa.id}
        getOptionLabel={(pessoa: UNCPessoa) =>
          `${showCodigo ? `${pessoa.id} - ` : ''}${
            pessoa.nome
          } - ${formataCpfOuCnpj(pessoa.cnpjCpf!)}`
        }
        onSearch={onSearch}
        onCreateValue={onCreateValue}
        getDetailOptionLabel={pessoa => (
          <>
            {`${showCodigo ? `${pessoa.id} - ` : ''}${
              pessoa.nome
            } - ${formataCpfOuCnpj(pessoa.cnpjCpf!)}`}
            <CustomLinkExternal
              forceRight
              identificador={''}
              uri={getUrl('unico', `/pessoas/${pessoa.id!}`)}
            />
          </>
        )}
        newValueLabel="Incluir pessoa"
      />
      {!!error && <span className="help-message">{error}</span>}
    </>
  );
};
